import React from 'react';
import './PortfolioWebsiteDevelopment.css';
import { Helmet } from "react-helmet-async";
const features = [
    "Responsive Design (Mobile-Friendly)",
    "Modern & Minimalist Layout",
    "Interactive Project Gallery",
    "Contact Form with Email Integration",
    "About & Services Sections",
    "SEO-Optimized Structure",
    "Fast Loading Speed",
    "Social Media Integration"
];

const benefits = [
    "Professional First Impression",
    "Showcase Your Work 24/7",
    "Custom Domain & Branding",
    "Improved Credibility & Trust",
    "Easier Client Outreach",
    "Control Over Your Personal Brand",
    "No Platform Limitations",
    "Perfect for Freelancers & Creators"
];

const useCases = [
    "Designers & Developers",
    "Photographers & Artists",
    "Freelancers & Consultants",
    "Writers & Journalists",
    "Architects & Engineers",
    "Influencers & Public Figures",
    "Students & Job Seekers",
    "Small Business Owners"
];

const PortfolioWebsiteDevelopment = () => {
    return (
        <div className="portfolio-container">
            <Helmet>
  <title>Portfolio Website Design | APTech Solution</title>
  <meta 
    name="description" 
    content="Showcase your work with a professional portfolio website. APTech Solution designs creative, mobile-friendly portfolio sites for individuals and businesses." 
  />
</Helmet>

            <h1 className="portfolio-title">Portfolio Website Development</h1>
            <p className="portfolio-subtitle">
                Showcase your skills, projects, and personality with a stunning, fast, and mobile-friendly portfolio website — built just for you.
            </p>

            <section className="portfolio-section">
                <h2 className="section-heading">Why a Portfolio Website?</h2>
                <p className="portfolio-paragraph">
                    A portfolio site is your digital identity. Whether you’re a freelancer, designer, developer, or artist, your portfolio website helps you stand out, build trust, and get hired.
                </p>
            </section>

            <section className="portfolio-section">
                <h2 className="section-heading">Key Features</h2>
                <div className="card-grid">
                    {features.map((feature, idx) => (
                        <div className="feature-card" key={idx}>
                            <span className="card-icon">🎨</span>
                            <p>{feature}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="portfolio-section">
                <h2 className="section-heading">Who Needs a Portfolio?</h2>
                <div className="card-grid">
                    {useCases.map((role, idx) => (
                        <div className="feature-card" key={idx}>
                            <span className="card-icon">💼</span>
                            <p>{role}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="portfolio-section">
                <h2 className="section-heading">Benefits of Having One</h2>
                <div className="card-grid">
                    {benefits.map((benefit, idx) => (
                        <div className="feature-card" key={idx}>
                            <span className="card-icon">🚀</span>
                            <p>{benefit}</p>
                        </div>
                    ))}
                </div>
            </section>

            <section className="cta-box">
                <h3>Let’s Build Your Personal Brand</h3>
                <p>Ready to stand out with a stunning portfolio website? Let’s craft something you’re proud to share.</p>
                <a href="https://wa.me/919316580274" target="_blank" rel="noopener noreferrer">
                    <button className="cta-button">Start Your Portfolio</button>
                </a>
                
            </section>
        </div>
    );
};

export default PortfolioWebsiteDevelopment;
